import ko from "knockout";
import register from "flow/knockout/register";

function formatWithComma(x: string, precision?: number, seperator?: string): string {
    const options = {
        precision: precision || 2,
        seperator: seperator || ","
    };
    if (x === undefined || x === null || x === "") {
        x = "0";
    }
    let formatted = parseFloat(x).toFixed(options.precision);
    const regex = new RegExp("^(-?\\d+)[^\\d](\\d{" + options.precision + "})$");
    formatted = formatted.replace(regex, "$1" + options.seperator + "$2");
    return formatted;
}

function reverseFormat(x: string) {
    if (x === undefined || x === null || x === "") {
        x = "0";
    }
    x = x.trim().replace(/\s/g, ""); // remove blankspaces for 10 000 etc
    const regex = new RegExp("^(\\d+)[^\\d](\\d+)$");
    const formatted = x.replace(regex, "$1.$2");
    return parseFloat(formatted);
}

/*

    Explanation of the RegExp used above:

    ^(\\d+)[^\\d](\\d{' + options.precision + '})$$

        ^        = pattern must match from the start of the string

        (\\d+)   = 1 or more digits
                   - the brackets capture the matched string
                     to be used in the replace function as $1

        [^\\d]   = any character but a digit
                   - this includes letters, whitespace and
                     punctutation (any character but 0-9)

        (\\d{X}) = X number of digits (above we use options.precision)
                   - the brackets capture the matched string
                     to be used in the replace function as $2

        $        = pattern must match to the end of the string
                   - here we've used ^...$ so the pattern must
                     match the entire string
    */

register.registerKnockoutBinding("commaDecimalFormatter", {
    init: function (element, valueAccessor) {
        let observable = valueAccessor();

        const interceptor = ko.computed({
            read: function () {
                let value = ko.isObservable(observable) ? observable() : observable;
                value = parseFloat(value) ? value : 0;
                return formatWithComma(value);
            },
            write: function (newValue) {
                newValue = parseFloat(newValue) ? newValue : "0";
                if (ko.isObservable(observable)) {
                    observable(reverseFormat(newValue));
                } else {
                    observable = reverseFormat(newValue);
                }
            }
        });

        if (element.tagName == "INPUT")
            ko.applyBindingsToNode(element, {
                value: interceptor
            });
        else
            ko.applyBindingsToNode(element, {
                text: interceptor
            });
    }
});
